import "./Header.scss";
import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import siteLogo from '../../../../assets/images/logo.png';
import BlankAvatar from '../../../../assets/images/blank-avatar.png';
import { imageUrlProfile, currencyBaseURL } from '../../../../services/CommonUrl';
import EnquiryForm from './../common/EnquiryForm';
import { useAuth } from "../../../../contexts/AuthProvider";
import axios from "axios";
import { DeleteModal } from "../../../../components/delete-modal";
import { clearAuthData } from "../../../../helpers";

const Header = () => {
    const { authed, setAuthed } = useAuth();
    const history = useHistory();
    const [isScrollClassHeader, setIsScrollClassHeader] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);

    const scrollHeader = () => {
        const handleScroll = () => {
            setIsScrollClassHeader(window.scrollY > 80);
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll);
    }

    const onClickLogout = () => {
        setAuthed({ isAuth: false, token: "", user: {} });
        clearAuthData();
        setShowDeleteModal(false);
        history.push("/signin");
    }

    useEffect(() => {
        scrollHeader();
        axios.get(currencyBaseURL).then((response) => {
            // console.log("currencyBaseURL", response)
            localStorage.setItem("currency_gw", JSON.stringify({ currency: response.data.currency, country: response.data.country }));
        });
    }, []);

    return (
        <>
            <header className={isScrollClassHeader ? "header-wrapper fixed-navbar" : "header-wrapper"}>
                <nav className="navbar navbar-expand-lg navbar-dark custom-nav" aria-label="navbar">
                    <div className="container-lg">
                        <Link className="logo" to="/"><img src={siteLogo} alt="Travey Club" className="img-responsive" /></Link>
                        <div className="navbar-right-box">
                            {authed?.isAuth === true ? (
                                <>
                                    <Dropdown className="headerDropdown-profile">
                                        <Dropdown.Toggle variant="transparent">
                                            {authed?.user?.profileImage === undefined || authed?.user?.profileImage === null || authed?.user?.profileImage === "" ? (
                                                <img src={BlankAvatar} alt="No Avatar" />
                                            ) : (
                                                <img src={imageUrlProfile + authed?.user?.profileImage} alt={authed?.user?.name || ""} />
                                            )}
                                            <span className="profileUserName">{authed?.user?.name}</span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item as="button" onClick={() => history.push("/admin/dashboard")} className="btn btn-primary-color">Dashboard</Dropdown.Item>
                                            <Dropdown.Item as="button" onClick={() => history.push("/admin/manage-profile")} className="btn btn-primary-color">Manage Profile</Dropdown.Item>
                                            <Dropdown.Item as="button" onClick={() => history.push("/subscriptions")} className="btn btn-primary-color">Pricing</Dropdown.Item>
                                            <Dropdown.Item as="button" onClick={() => history.push("/admin/manage-subscription")} className="btn btn-primary-color">Manage Plan</Dropdown.Item>
                                            <Dropdown.Divider className="bg-white border-0" />
                                            <Dropdown.Item as="button" onClick={() => history.push("/about")} className="btn btn-primary-color">About Us</Dropdown.Item>
                                            <Dropdown.Item as="button" onClick={() => setShowEnquiryModal(true)} className="btn btn-primary-color">Enquire</Dropdown.Item>
                                            <Dropdown.Item as="button" onClick={() => setShowDeleteModal(true)} className="btn btn-primary-color">Logout</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </>
                            ) : (
                                <div className="login-links">
                                    <Link to="/signin" className="btn"><span>Sign in</span><i className="h-icon h-signin-icon"></i></Link>
                                    <Link to="/help-support" className="btn"><span>Support</span><i className="h-icon h-support-icon"></i></Link>
                                    <button type="button" className="btn btn-enquire" onClick={() => setShowEnquiryModal(true)}><span>Enquire</span><i className="h-icon h-enquire-icon"></i></button>
                                    <Link className="btn" to="/subscriptions"><span>Pricing</span><i className="h-icon h-subscription-icon"></i></Link>
                                </div>
                            )}
                            {/* <Dropdown className="headerDropdown-moretravel">
                            <Dropdown.Toggle variant="transparent">
                                <span>More Travel</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to={'/stays-results'}><i className="fa fa-building"></i> Stays</Dropdown.Item>
                                <Dropdown.Item><i className="fa fa-plane"></i> Flights</Dropdown.Item>
                                <Dropdown.Item><i className="fa fa-briefcase"></i> Tours</Dropdown.Item>
                                <Dropdown.Item><i className="fa fa-binoculars"></i>Activities</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}

                        </div>
                    </div>
                </nav>
            </header>

            {showDeleteModal && (
                <DeleteModal
                    message={"Are you sure you want to logout"}
                    showDeleteModal={showDeleteModal}
                    setShowDeleteModal={setShowDeleteModal}
                    confirmFnc={() => onClickLogout()}
                    isLoading={""}
                />
            )}
            
            <EnquiryForm
                showEnquiryModal={showEnquiryModal}
                setShowEnquiryModal={setShowEnquiryModal}
            />
        </>
    );
}

export default Header;